import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=1fa79847&scoped=true"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"
import style0 from "./MyPlan.vue?vue&type=style&index=0&id=1fa79847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa79847",
  null
  
)

export default component.exports